import AxiosHttpClient from 'app/api/AxiosHttpClient';
import { ResourceFormat } from 'app/model/ResourceFormat';
import { FilesUtils } from 'app/utils/FilesUtils';

export class ResourceService {
    private apiClient: AxiosHttpClient;

    constructor(apiClient: AxiosHttpClient) {
        this.apiClient = apiClient;
    }

    async downloadResource(url: string, format: ResourceFormat) {
        const response = await this.apiClient.executeDownload(url);
        return FilesUtils.getFileInformation(response, format);
    }
}
